import styled from "styled-components";
import Checkbox from "../components/Controls/Checkbox";
import { AddItemInput } from "../components/Controls/AddItemInput";
import { SearchInput } from "../components/Controls/SearchInput";
import ScrollEffect from "../effects/ScrollEffect";

export const selectWithOptions = (Component) => (props) => {
  return (
    <Container onClick={props?.setShowOptions}>
      <Component {...props} />
      {props?.showOptions && (
        <OptionsStyle>
          {props?.searchable && <SearchInput width="200px" />}
          {props?.selectable && <Checkbox label="Select all" />}
          <ScrollEffect height={props?.scrollHeight || "200px"}>
            {props?.options.map((o, index) => (
              <OptionStyle key={index}>{o}</OptionStyle>
            ))}
          </ScrollEffect>
          {props?.addable && <AddItemInput width="200px" />}
        </OptionsStyle>
      )}
    </Container>
  );
};

const Container = styled.div``;

const OptionsStyle = styled.div`
  display: grid;
  justify-content: center;
  gap: 5px;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  box-shadow: 1px 6px 12px grey;
  padding: 5px 0;
  border: 1px solid lightgray;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  width: 100%;
  z-index: 100;
`;

const OptionStyle = styled.span`
  display: block;
  padding: 0 5px;
  border-bottom: ${(props) =>
    props.selected ? "2px solid #008060" : "1px solid lightgray"};

  &&:hover {
    background-color: aliceblue;
  }

  &:first-child {
    background-color: #e5e5e5;
    margin-top: 10px;
    &:hover {
      background-color: #e5e5e5;
    }
  }
  &:last-child {
    margin-bottom: 10px;
  }
`;
